module.exports = __webpack_public_path__ + "static/media/categry-03_crowd.64f8f166.png";